module.exports = __webpack_public_path__ + "static/preview__heading-e0c1c575403bd8dfd35f51e0776044dd.png";